import { type IconName } from '../components/Icon';

export function getPaymentMethodIcon(paymentMethod: string | null | undefined): IconName {
  const normalizedPaymentMethod = paymentMethod
    ?.trim()
    .replace(/[\s_-]+/g, '')
    .toLowerCase();

  switch (normalizedPaymentMethod) {
    case 'card': {
      return 'IconCreditCard';
    }

    case 'visa': {
      return 'IconCcVisa';
    }

    case 'mastercard': {
      return 'IconCcMasterCard';
    }

    case 'americanexpress':
    case 'amex': {
      return 'IconCcAmex';
    }

    case 'discover': {
      return 'IconCcDiscover';
    }

    case 'applepay': {
      return 'IconApplePayPayment';
    }

    case 'googlepay': {
      return 'IconGooglePay';
    }

    case 'cashapp': {
      return 'IconCashApp';
    }

    case 'link': {
      return 'IconLink';
    }

    default: {
      return 'IconCreditCard';
    }
  }
}
